/**
 * Reference mobile side-menu theme icons (bdvegas.online .menu-first).
 * Sourced from img.b100vg.com/bvg/h5/assets/images/icon-set/theme-icon/
 * Copied locally — no runtime hotlink.
 *
 * Category icons (hot/sports/...) stay in ../category-icons/ (already verified).
 */
import home from './icon-home.png';
import promotion from './icon-promotion.png';
import winnerBoard from './icon-winner-board.png';
import vip from './icon-vip.png';
import referral from './icon-referral.png';
import talk from './icon-talk.png';
import { CATEGORY_ICON_SRC } from '../category-icons/index.js';

export const MENU_ICON_SRC = {
  home,
  hot: CATEGORY_ICON_SRC.hot,
  sports: CATEGORY_ICON_SRC.sports,
  casino: CATEGORY_ICON_SRC.casino,
  slots: CATEGORY_ICON_SRC.slots,
  crash: CATEGORY_ICON_SRC.crash,
  table: CATEGORY_ICON_SRC.table,
  fishing: CATEGORY_ICON_SRC.fishing,
  arcade: CATEGORY_ICON_SRC.arcade,
  lottery: CATEGORY_ICON_SRC.lottery,
  promotion,
  winnerBoard,
  vip,
  referral,
  talk,
};

/** Reference .menu-first vendor order + labels (bdvegas.online). */
export const REF_MENU_CAT_ORDER = [
  'hot',
  'sports',
  'casino',
  'slots',
  'crash',
  'table',
  'fishing',
  'arcade',
  'lottery',
];

export const REF_MENU_CAT_LABELS = {
  hot: 'HOT',
  sports: 'SPORTS',
  casino: 'CASINO',
  slots: 'SLOTS',
  crash: 'CRASH',
  table: 'TABLE',
  fishing: 'FISHING',
  arcade: 'ARCADE',
  lottery: 'LOTTERY',
};
